var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlechaIzq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.875 35.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2680",
    "data-name": "Trazado 2680",
    d: "M18.41,2.074,20,.488A.961.961,0,0,0,20-.871L7.573-13.293H34.914a.961.961,0,0,0,.961-.961V-16.5a.961.961,0,0,0-.961-.961H7.573L20-29.879a.961.961,0,0,0,0-1.359L18.41-32.824a.961.961,0,0,0-1.359,0L.281-16.054a.961.961,0,0,0,0,1.359L17.051,2.074A.961.961,0,0,0,18.41,2.074Z",
    transform: "translate(0 33.105)",
    fill: "#345eea"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaIzq);
export default __webpack_public_path__ + "static/media/flecha-izq.1a2bfa545ba13a083a1c52c24577d8f5.svg";
export { ForwardRef as ReactComponent };